import script from "./HomepageDesignmuseumgent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageDesignmuseumgent.vue?vue&type=script&setup=true&lang=js"

import "./HomepageDesignmuseumgent.vue?vue&type=style&index=0&id=ba333340&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba333340"]])

export default __exports__